import { Injectable } from '@angular/core';
import { createInitialState, GiftVoucherFormStore } from './gift-voucher-form.store';
import { CompanyQuery } from '../company/company.query';

@Injectable({ providedIn: 'root' })
export class GiftVoucherFormService {
    constructor(
        private giftVoucherFormStore: GiftVoucherFormStore,
        private companyQuery: CompanyQuery,
    ) { }

    get nameSplit(): boolean {
        return this.companyQuery.nameSplit;
    }


    resetGiftVoucherFormData() {
        this.giftVoucherFormStore.update(createInitialState());
    }

    resetStore() {
        this.giftVoucherFormStore.reset();
    }

    buildUrlParameters() {
        const store = this.giftVoucherFormStore.getValue();
        const name = store.isGifting ? store.name : '';
        const phone = store.isGifting ? store.phone : '';
        const email = store.isGifting ? store.email : '';
        const sendEmail = store.isGifting && store.sendEmail ? '-1' : '0';
        const surname1 = store.isGifting && this.companyQuery.nameSplit ? store.surname1 : '';
        const surname2 = store.isGifting && this.companyQuery.nameSplit ? store.surname2 : '';

        const params = `&ClientRefereeName=${name}&ClientRefereeSurname1=${surname1}&ClientRefereeSurname2=${surname2}&ClientRefereePhone=${phone}&ClientRefereeEmail=${email}&ShouldReceiveEmail=${sendEmail}`;

        return params;
    }
}
